<template>
  <Modal
    v-model="showModal"
    title="话题"
    width="627"
    @on-cancel="cancel"
    :styles="{ top: '100px' }"
  >
    <div style="background-color: #fff">
      <div class="flex align-center justify-start">
        <img
          :src="getAdminAvatar(info.creator_avatar)"
          class="avatar"
          v-if="info.creator_type == 'employee'"
        />
        <img
          :src="getAvatar(info.creator_avatar)"
          class="avatar"
          v-if="info.creator_type == 'user'"
        />

        <span class="margin-left-5" v-if="info.creator_type == 'employee'"
          >衣创社区官方客服</span
        >
        <span class="margin-left-5" v-if="info.creator_type == 'user'">{{
          info.creator_name
        }}</span>
        <span class="margin-left-5">{{ info.create_time }}</span>
      </div>
      <div
        class="flex align-center justify-start"
        style="position: relative; margin-top: 10px"
      >
        <template v-if="info.message_type == 'text'">
          <div class="message">{{ info.message }}</div>
        </template>
        <template
          v-if="info.message_type == 'file' || info.message_type == 'img'"
        >
          <div class="file-box">
            <a
              v-for="(file, i) in info.message_file"
              :key="i"
              :href="file.url"
              target="_blank"
            >
              <div class="file-name" v-if="file.type == 'file'">
                {{ file.name }}
              </div>
              <img :src="file.url" v-if="file.type == 'img'" class="file-img" />
            </a>
          </div>
        </template>
        <template v-if="info.message_type == 'design'">
          <div class="design_info" @click="goDesign(info.design_info.uuid)">
            <div class="left">
              <img
                :src="info.design_info.image | default_img"
                alt=""
                class="image"
              />
            </div>
            <div class="right">
              <div class="name-wrap">
                <div class="name">{{ info.design_info.name }}</div>
              </div>
              <div class="style_no">
                <span>款号</span>
                ：{{ info.design_info.style_no }}
              </div>
              <div class="category">
                <span>款式分类</span>
                ：{{ info.design_info.product_category_name }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="info.message_type == 'order'">
          <div class="design_info" @click="goOrder(info.order_info.order_id)">
            <div class="left">
              <img
                :src="info.order_info.style_img | default_img"
                alt=""
                class="image"
              />
            </div>
            <div class="right">
              <div class="name-wrap">
                <div class="name">订单号:{{ info.order_info.order_no }}</div>
              </div>
              <div class="style_no">
                <span>款式</span>
                ：{{ info.order_info.style_name }}
              </div>
              <div class="category">
                <span>款式分类</span>
                ：{{ info.order_info.product_category_name }}
              </div>
            </div>
          </div>
        </template>
        <template
          v-if="
            info.message_type == 'fabric' ||
            info.message_type == 'accessory'
          "
        >
          <div
            class="fabric_accessory_info"
            @click="
              goFabricAccessory(
                info.fabric_accessory.id,
                info.message_type
              )
            "
          >
            <img
              :src="info.fabric_accessory.image | default_img"
              alt=""
              class="image"
            />

            <div class="name">
              {{ info.fabric_accessory.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="chat-list">
      <div class="chat-content" id="chat-content">
        <div v-for="(item, index) in list" :key="index">
          <div v-if="item.recall == 1" class="flex align-center justify-center">
            <span v-if="item.creator_id == userInfo.id">你撤回了一条消息</span>
            <span v-if="item.creator_id != userInfo.id"
              >对方撤回了一条消息</span
            >

            <span
              v-if="item.canEditReCall && item.message_type == 'text'"
              style="color: #0077dd"
              @click="editReCall(item)"
              >重新編輯</span
            >
          </div>
          <template v-if="item.recall == 0">
            <div
              style="text-align: right; padding-bottom: 5px; font-size: 12px"
              v-if="item.creator_id == userInfo.id"
            >
              {{ item.create_time }}
            </div>
            <div
              style="text-align: left; padding-bottom: 5px; font-size: 12px"
              v-if="item.creator_id != userInfo.id"
            >
              {{ item.create_time }}
            </div>
            <div
              class="chat-item"
              :class="
                item.creator_id == userInfo.id
                  ? 'chat-item-right'
                  : 'chat-item-left'
              "
            >
              <template v-if="item.creator_id == userInfo.id">
                <div class="message-box">
                  <template v-if="item.message_type == 'text'">
                    <div class="message">{{ item.message }}</div>
                  </template>
                  <template
                    v-if="
                      item.message_type == 'file' || item.message_type == 'img'
                    "
                  >
                    <div class="file-box">
                      <a
                        v-for="(file, i) in item.message_file"
                        :key="i"
                        :href="file.url"
                        target="_blank"
                      >
                        <div class="file-name" v-if="file.type == 'file'">
                          {{ file.name }}
                        </div>
                        <img
                          :src="file.url"
                          v-if="file.type == 'img'"
                          class="file-img"
                        />
                      </a>
                    </div>
                  </template>
                  <template v-if="item.message_type == 'design'">
                    <div
                      class="design_info"
                      @click="goDesign(item.design_info.uuid)"
                    >
                      <div class="left">
                        <img
                          :src="getStyleImg(item.design_info.image)"
                          alt=""
                          class="image"
                        />
                      </div>
                      <div class="right">
                        <div class="name-wrap">
                          <div class="name">{{ item.design_info.name }}</div>
                        </div>
                        <div class="style_no">
                          <span>款号</span>
                          ：{{ item.design_info.style_no }}
                        </div>
                        <div class="category">
                          <span>款式分类</span>
                          ：{{ item.design_info.product_category_name }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="item.message_type == 'order'">
                    <div
                      class="design_info"
                      @click="goOrder(item.order_info.uuid)"
                    >
                      <div class="left">
                        <img
                          :src="getStyleImg(item.order_info.style_img)"
                          alt=""
                          class="image"
                        />
                      </div>
                      <div class="right">
                        <div class="name-wrap">
                          <div class="name">
                            订单号:{{ item.order_info.order_no }}
                          </div>
                        </div>
                        <div class="style_no">
                          <span>款式</span>
                          ：{{ item.order_info.style_name }}
                        </div>
                        <div class="category">
                          <span>款式分类</span>
                          ：{{ item.order_info.product_category_name }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template
                    v-if="
                      item.message_type == 'fabric' ||
                      item.message_type == 'accessory'
                    "
                  >
                    <div
                      class="fabric_accessory_info"
                      @click="
                        goFabricAccessory(
                          item.fabric_accessory.id,
                          item.message_type
                        )
                      "
                    >
                      <img
                        :src="
                          item.fabric_accessory.image
                            | default_img
                        "
                        alt=""
                        class="image"
                      />

                      <div class="name">
                        {{ item.fabric_accessory.name }}
                      </div>
                    </div>
                  </template>
                </div>
                <img :src="getAvatar(item.creator_avatar)" class="avatar" />
              </template>
              <template v-if="item.creator_id != userInfo.id">
                <img
                  :src="getAdminAvatar(item.creator_avatar)"
                  class="avatar"
                  v-if="item.creator_type == 'employee'"
                />
                <img
                  :src="getAvatar(item.creator_avatar)"
                  class="avatar"
                  v-if="item.creator_type == 'user'"
                />
                <div class="message-box">
                  <template v-if="item.message_type == 'text'">
                    <div class="message">{{ item.message }}</div>
                  </template>
                  <template
                    v-if="
                      item.message_type == 'file' || item.message_type == 'img'
                    "
                  >
                    <div class="file-box">
                      <a
                        v-for="(file, i) in item.message_file"
                        :key="i"
                        :href="file.url"
                        target="_blank"
                      >
                        <div class="file-name" v-if="file.type == 'file'">
                          {{ file.name }}
                        </div>
                        <img
                          :src="file.url"
                          v-if="file.type == 'img'"
                          class="file-img"
                        />
                      </a>
                    </div>
                  </template>
                  <template v-if="item.message_type == 'design'">
                    <div
                      class="design_info"
                      @click="goDesign(item.design_info.uuid)"
                    >
                      <div class="left">
                        <img
                          :src="getStyleImg(item.design_info.image)"
                          alt=""
                          class="image"
                        />
                      </div>
                      <div class="right">
                        <div class="name-wrap">
                          <div class="name">{{ item.design_info.name }}</div>
                        </div>
                        <div class="style_no">
                          <span>款号</span>
                          ：{{ item.design_info.style_no }}
                        </div>
                        <div class="category">
                          <span>款式分类</span>
                          ：{{ item.design_info.product_category_name }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="item.message_type == 'order'">
                    <div
                      class="design_info"
                      @click="goOrder(item.order_info.uuid)"
                    >
                      <div class="left">
                        <img
                          :src="getStyleImg(item.order_info.style_img)"
                          alt=""
                          class="image"
                        />
                      </div>
                      <div class="right">
                        <div class="name-wrap">
                          <div class="name">
                            订单号:{{ item.order_info.order_no }}
                          </div>
                        </div>
                        <div class="style_no">
                          <span>款式</span>
                          ：{{ item.order_info.style_name }}
                        </div>
                        <div class="category">
                          <span>款式分类</span>
                          ：{{ item.order_info.product_category_name }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template
                    v-if="
                      item.message_type == 'fabric' ||
                      item.message_type == 'accessory'
                    "
                  >
                    <div
                      class="fabric_accessory_info"
                      @click="
                        goFabricAccessory(
                          item.fabric_accessory.id,
                          item.message_type
                        )
                      "
                    >
                      <img
                        :src="
                          item.fabric_accessory.image
                            | default_img
                        "
                        alt=""
                        class="image"
                      />

                      <div class="name">
                        {{ item.fabric_accessory.name }}
                      </div>
                    </div>
                  </template>
                </div>
                
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="submit" @click="cancel">关闭</div>
    </div>
    <FabricAccessoryShow
      ref="fabricAccessoryShow"
    ></FabricAccessoryShow>
  </Modal>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getQuoteChatList } from "@/api/chat.js";
import FabricAccessoryShow from "@/components/FabricAccessoryShow";
export default {
  name: "ChatQuote",
  props: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      showModal: false,
      list: [],
      info: {},
    };
  },
  components: {
    FabricAccessoryShow
  },
  watch: {},
  methods: {
    getAvatar(creator_avatar) {
      return creator_avatar || require("@/assets/images/chat/avatar.png");
    },
    getStyleImg(img) {
      return img || require("@/assets/images/default.jpg");
    },
    getAdminAvatar(creator_avatar) {
      return creator_avatar || require("@/assets/images/chat/chat-logo.png");
    },
    goDesign(uuid) {
      const uri = `${window.location.origin}/workbench/design?uuid=${uuid}`;
      window.open(uri, "_blank");
    },
    goOrder(uuid) {
      const uri = `${window.location.origin}/order/detail?uuid=${uuid}`;
      console.log("uri", uri);
      window.open(uri, "_blank");
    },
     goFabricAccessory(id,type) {
      this.$refs.fabricAccessoryShow.show(id,type)
    },
    show(chat_uuid) {
      this.getQuoteList(chat_uuid);
      this.showModal = true;
    },

    async getQuoteList(chat_uuid) {
      return getQuoteChatList({
        chat_uuid,
      }).then((response) => {
        this.info = response.data[0];
        this.list = response.data.filter((i, index) => {
          return index > 0;
        });
      });
    },
    cancel() {
      this.showModal = false;
    },
    submit() {},
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}
.margin-left-5 {
  margin-left: 5px;
}
.flex {
  display: flex;
}

.flex-sub {
  flex: 1;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.text-12 {
  font-size: 12px;
}

.text-999 {
  color: #999;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-left-10 {
  margin-left: 10px;
}

.over-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
 .fabric_accessory_info {
  cursor: pointer;
  height: 150px;
  width: 120px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .image {
    border: 1px solid #ebedf2;
    height: 120px;
    width: 120px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
  }
  .name {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    padding: 0 5px;
  }
}
.chat-list {
  margin-top: 20px;
  .chat-content {
    height: 535px;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #f5f5f5;
    padding: 20px;
    .chat-item {
      display: flex;
      margin-bottom: 20px;
      // align-items: center;
      .chat-item-action {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .action-item-box {
          padding: 10px;
          .action-item {
            text-align: center;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .message-box {
        border-radius: 5px;
        padding: 10px;
        .quote-message-box {
          padding-bottom: 10px;
          cursor: pointer;
          .message {
            color: #999999;
          }
        }
        .message {
          max-width: 360px;
          padding: 5px;
          color: #262626;
        }

        .file-box {
          max-width: 360px;
          .file-img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }

    .chat-item-left {
      justify-content: flex-start;
      .message-box {
        margin-left: 10px;
        background: #ffffff;
        .quote-message-box {
          border-bottom: 1px solid #dddddd;
        }
      }
    }

    .chat-item-right {
      justify-content: flex-end;
      .message-box {
        margin-right: 10px;
        background: #e6e6e6;
        .quote-message-box {
          border-bottom: 1px solid #f5f5f5;
        }
      }
    }
  }

  .chat-input {
    height: 71px;
    width: 100%;
    background: #ffffff;

    .chat-input-textarea {
      font-style: normal;
      width: 100%;
      border: none;
      padding: 10px;
      outline: none;
    }
  }

  .chat-content::-webkit-scrollbar {
    display: none;
  }
 
  .design_info {
    display: flex;
    flex-wrap: nowrap;
    flex: 0 1 48%;
    height: 120px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ebedf2;
    cursor: pointer;

    .left {
      width: 120px;
      height: 100%;
      .image {
        border: 1px solid #ebedf2;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px 0 0 10px;
      }
    }
    .right {
      margin: 0 20px;
      text-align: left;
      flex: 1;
      .name-wrap {
        height: 53px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ebedf2;
        .name {
          font-size: 16px;
          color: #333333;
          font-weight: bold;
        }
        .status {
          width: 70px;
          height: 25px;
          line-height: 25px;
          border-radius: 5px 0px 5px 0px;
          text-align: center;
          font-family: "Microsoft YaHei";
          &.draft {
            color: #30c6d0;
            border: 1px solid #30c6d0;
          }
          &.bargain {
            color: #ff9000;
            border: 1px solid #ff9000;
          }
          &.confirm_design {
            color: #e72c28;
            border: 1px solid #e72c28;
          }
        }
      }

      .style_no,
      .category,
      .desc {
        margin: 6px 0;
        color: #707070;
        font-size: 14px;
      }
      .desc {
        height: 40px;
        overflow-y: hidden;
      }

      span {
        color: #4d4d4d;
        font-size: 14px;
      }

      .time {
        margin: 5px 0;
        font-size: 12px;
        color: #808080;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>
